import React, { useState } from "react";
import "./SortingDropdown.scss";
import DropDownArrow from "../SvgReactIcons/DropdownDownArrow";
import { Options } from "modules/1-on-1s/types";

interface SortingDropdownProps {
  text: string;
  options: Options[];
  onChange?: (value: Options) => void;
}

const SortingDropdown: React.FC<SortingDropdownProps> = ({
  text,
  options,
  onChange,
}) => {
  const [showDropDown, setShowDropDown] = useState(false);
  return (
    <div
      onClick={() => setShowDropDown(!showDropDown)}
      className="SortingDropdown"
    >
      <div className="container-text">
        <div className="text">{text}</div>
        <DropDownArrow />
      </div>
      {options.length > 0 && showDropDown && (
        <div className="sortingDropdownOptions">
          {options.map((item, index) => (
            <div
              key={index}
              onClick={() => {
                onChange?.(item);
              }}
              className="options"
            >
              {item?.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortingDropdown;
